import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';

;(function (window, document) {
    let chartCanvas = document.getElementById("barChart");
    if (chartCanvas) {
        let chartData = JSON.parse(chartCanvas.dataset.chartData);
        lineChartInitialization(chartCanvas, chartData);
    }
    let percentChartCanvas = document.getElementById("percentChart");
    if (percentChartCanvas) {
        let chartData = JSON.parse(percentChartCanvas.dataset.chartData);
        lineChartInitialization(percentChartCanvas, chartData);
    }

    function lineChartInitialization(chartCanvas, chartData) {
        new Chart(chartCanvas, {
            type: 'line',
            data: {
                datasets: chartData
            },
            options: {
                scales: {
                    x: {
                        type: 'time',
                        time: {
                            unit: 'day',
                            tooltipFormat: 'dd.MM.yyyy',
                            displayFormats: {
                                day: 'dd.MM.yyyy' // формат даты
                            }
                        },
                        title: {
                            display: true,
                            text: 'Дата'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Значение'
                        }
                    }
                }
            }
        });
    }
})(window, document);
